import stageConfig from '@/config/stage' // 引入舞台配置

/**
 * 深度遍历配置树, 摘取叶子节点作为路由部分
 * @param {*} config 配置项
 * @param {*} fuc 回调函数
 */
function deepTravel(config, fuc) {
  if (Array.isArray(config)) {
    config.forEach(subConfig => {
      deepTravel(subConfig, fuc)
    })
  } else if (config.children?.length) {
    config.children.forEach(subConfig => {
      deepTravel(subConfig, fuc)
    })
  } else {
    fuc(config)
  }
}

const homeRouter = []

/**
 * 构造舞台view路由
 */
deepTravel(stageConfig, viewConfig => {
  const viewRouter = {}
  viewRouter.path = viewConfig.route
  viewRouter.name = viewConfig.name
  viewRouter.component = () => import(`@/${viewConfig.filePath}`)
  viewRouter.meta = {
    title: viewConfig.title,
    icon: viewConfig.icon,
    permission: viewConfig.permission,
    type: viewConfig.type,
    blueBaseColor: viewConfig.blueBaseColor ? 'viewConfig.blueBaseColor' : '',
  }
  homeRouter.push(viewRouter)
})

// 添加详情页和报告页路由（不在stage配置中）
// 注意：详情页路由需要在列表页路由之后添加，确保路径匹配正确
homeRouter.push({
  path: '/business/smart-contract/:id(\\d+)',
  name: 'SmartContractDetail',
  component: () => import('@/view/business/smart-contract/detail.vue'),
  meta: {
    title: '智能合约详情',
    type: 'view',
    icon: 'iconfont icon-hetong',
  }
})

homeRouter.push({
  path: '/business/smart-contract/sign/:id(\\d+)',
  name: 'SmartContractSign',
  component: () => import('@/view/business/smart-contract/sign.vue'),
  meta: {
    title: '合同签署',
    type: 'view',
    icon: 'iconfont icon-hetong',
  }
})

homeRouter.push({
  path: '/business/report',
  name: 'BusinessReport',
  component: () => import('@/view/business/report/index.vue'),
  meta: {
    title: '业务报告',
    type: 'view',
    icon: 'iconfont icon-baogao',
  }
})

homeRouter.push({
  path: '/business/digital-certificate/:id(\\d+)',
  name: 'DigitalCertificateDetail',
  component: () => import('@/view/business/digital-certificate/detail.vue'),
  meta: {
    title: '数字凭证详情',
    type: 'view',
    icon: 'iconfont icon-pingzheng',
  }
})

homeRouter.push({
  path: '/business/account-receivable/:id(\\d+)',
  name: 'AccountReceivableDetail',
  component: () => import('@/view/business/account-receivable/detail.vue'),
  meta: {
    title: '应收账款详情',
    type: 'view',
    icon: 'iconfont icon-hetong',
  }
})

homeRouter.push({
  path: '/business/project/:id(\\d+)',
  name: 'BusinessProjectDetail',
  component: () => import('@/view/business/project/detail.vue'),
  meta: {
    title: '项目详情',
    type: 'view',
    icon: 'iconfont icon-xiangmu',
  }
})

export default homeRouter
